<template>
    <div class="animated fadeIn">
        <div class="card admin">
            <div class="card-header">
                Список ролей
                <div class="pull-right" style="margin-top: 7px">
                    <button class="btn btn-secondary" :class="{ active: showFilter }" data-toggle="dropdown" href="#" @click.prevent="showFilter = !showFilter">
                        <i class="fa fa-filter"></i> Фильтр
                    </button>
                    <button class="btn btn-primary" @click.prevent="showModal">
                        <i class="fa fa-plus"></i> Добавить роль
                    </button>
                </div>
                <div v-if="showFilter" class="mt-3 mt-lg-1">
                    <div class="row col-12 col-md-6">
                        <form @submit.prevent="search" сlass="form-horizontal">
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label">Название</label>
                            <div class="col-md-9 col-lg-5">
                                <input type="text" class="form-control" v-model="params.query">
                            </div>
                        </div>
                        </form>
                    </div>
                    <div class="col-6"></div>
                </div>
            </div>
            <div class="card-block admin__list">
                <div class="row mb-1 small text-muted">
                    <div class="col-1 d-none d-md-block">Id</div>
                    <div class="col-6 col-md-4">Код</div>
                    <div class="col-6 col-md-2">Назвние</div>
                    <div class="col-6 col-md-2">Разрешения</div>
                    <div class="col-6 col-md-3">Управление</div>
                </div>
                <loading v-if="loading" message="Загружаем роли..."></loading>
                <div v-else class="row mb-1 admin__list__item admin__list__item_hover-bg-gray"  v-for="item in items">
                    <div class="col-1 d-none d-md-block">
                        {{item.id}}
                    </div>
                    <div class="col-6 col-md-4">
                       {{item.name}}
                    </div>
                    <div class="col-6 col-md-2">
                        {{item.description}}
                    </div>
                    <div class="col-6 col-md-2">
                        <!--TODO-->
                        <!--{{item.sort}}-->
                    </div>
                    <div class="col-6 col-md-3">
                        <button class="btn btn-primary btn-sm" @click.prevent="editItem(item)">
                            <i class="fa fa-edit"></i> Изменить
                        </button>
                        <!--<button  class="btn btn-danger btn-sm" >-->
                            <!--<i class="fa fa-lock"></i> Заблокировать-->
                        <!--</button>-->
                    </div>
                </div>
            </div>
            <div class="card-header">
                <b-pagination class="mb-0" size="md" :total-rows="itemsPage.paginator.total_count" v-model="params.page" :per-page="itemsPage.paginator.limit">
                </b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
  import getRolesQuery from './../../gql/queries/Acl/getRoles.graphql'
  import { mapActions } from 'vuex'
  import { ADD_TOAST_MESSAGE } from 'vuex-toast'
  export default {
    computed: {
      items () {
        return this.itemsPage.roles
      }
    },
    data () {
      return {
        params: {
          page: 1,
          query: ''
        },
        itemsPage: {
          roles: null,
          paginator: {
            total_count: 10
          }
        },
        showFilter: false,
        loading: false
      }
    },
    name: 'roles',
    components: {
        //
    },
    methods: {
      showModal () {
        this.$store.dispatch('setAdminModal', 'addEditRole')
      },
      editItem (item) {
        this.$store.commit('SET_ADMIN_EDIT_ROLE', item)
        this.showModal()
      },
      ...mapActions({
        addToast: ADD_TOAST_MESSAGE
      })
    },
    apollo: {
      itemsPage: {
        query: getRolesQuery,
        variables () {
          return {
            page: this.params.page,
            query: this.params.query,
            all: false
          }
        },
        fetchPolicy: 'network-only',
        watchLoading (isLoading, countModifier) {
          this.loading = isLoading
        },
        update: (data) => {
          return data
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Roles.vue?5f4f8ba8